import { serviceRoutes, get, post } from "./index";

export const consultarTiqueteraPorSerial = async ({ serial }) => get(serviceRoutes.consultarTiqueteraPorSerial, `?serial=${serial}`);

export const asociarTiquetera = async (body) => post(serviceRoutes.asociarTiquetera, body);

export const consultarTiqueterasPorEmisor = async ({ emisor }) => get(serviceRoutes.consultarTiqueterasPorEmisor, `?emisor=${emisor}`);
